class ContentEngineService {
  private selectedTopic: { id: number; name: string } | null = null;
  private selectedScript: any = null;
  private scriptsCache: { topicId: number; scripts: any[] } | null = null;
  private attributesCache: { topicId: number; attributes: Record<string, string> } | null = null;
  private newCreativeIdsCache: Set<number> = new Set();
  private scriptPreview: string | null = null;
  private creativeVersionId: number | null = null;
  private selectedContentFormat: { id: number; name: string } | null = null;
  private generatedContentsCache: { topicId: number; contents: any[] } | null = null;

  setSelectedTopic(id: number, name: string) {
    this.selectedTopic = { id, name };
    this.selectedScript = null;
    this.selectedContentFormat = null;
    this.generatedContentsCache = null;
  }

  getSelectedTopic() {
    return this.selectedTopic;
  }

  setSelectedContentFormat(id: number, name: string) {
    this.selectedContentFormat = { id, name };
  }

  getSelectedContentFormat() {
    return this.selectedContentFormat;
  }

  setGeneratedContents(topicId: number, contents: any[]) {
    this.generatedContentsCache = { topicId, contents };
  }

  getGeneratedContents(topicId: number) {
    if (this.generatedContentsCache?.topicId === topicId) {
      return this.generatedContentsCache.contents;
    }
    return null;
  }

  setSelectedScript(script: any) {
    this.selectedScript = script;
  }

  getSelectedScript() {
    return this.selectedScript;
  }

  setCachedScripts(topicId: number, scripts: any[]) {
    this.scriptsCache = { topicId, scripts };
  }

  getCachedScripts(topicId: number) {
    if (this.scriptsCache?.topicId === topicId) {
      return this.scriptsCache.scripts;
    }
    return null;
  }

  setCachedAttributes(topicId: number, attributes: Record<string, string>) {
    this.attributesCache = { topicId, attributes };
  }

  getCachedAttributes(topicId: number) {
    if (this.attributesCache?.topicId === topicId) {
      return this.attributesCache.attributes;
    }
    return null;
  }

  getNewCreativeIds() {
    return this.newCreativeIdsCache;
  }

  setNewCreativeIds(ids: Set<number>) {
    this.newCreativeIdsCache = ids;
  }

  clearNewCreativeIds() {
    this.newCreativeIdsCache = new Set();
  }

  setScriptPreview(content: string) {
    this.scriptPreview = content;
  }

  getScriptPreview() {
    return this.scriptPreview;
  }

  setCreativeVersionId(id: number) {
    this.creativeVersionId = id;
  }

  getCreativeVersionId() {
    return this.creativeVersionId;
  }

  clearCache() {
    this.scriptsCache = null;
    this.attributesCache = null;
    this.selectedScript = null;
    this.selectedTopic = null;
    this.selectedContentFormat = null;
    this.generatedContentsCache = null;
    this.newCreativeIdsCache = new Set();
    this.scriptPreview = null;
    this.creativeVersionId = null;
  }
}

export const contentEngineService = new ContentEngineService();
